module.exports = __webpack_public_path__ + "img/index-desc-3-pic.3df5b1cd.png";